import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import React from 'react';
import './NavBar.scss';

interface NavBarItemProps {
    children: React.ReactElement;
}

const NavBarItemWithOverlay = ({ children }: NavBarItemProps): React.ReactElement => {
    const tooltip = <div className="NavBar-Tooltip">Page not available</div>;
    return (
        <OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }} overlay={tooltip}>
            <div className="NavBar-Tooltip-Container">{children}</div>
        </OverlayTrigger>
    );
};

export default NavBarItemWithOverlay;
